/**
 * Call manifest — `call` action.
 *
 * Walks any source → contact (must have phone). Opens the Hub send-text
 * modal (Quo call available inside the modal).
 *
 * For deals: walks deal → company → contact (pick).
 */

import { registerActionManifest } from "./registry";
import { openSendTextMessageModal } from "./helpers/openSendTextMessage";

registerActionManifest({
  actionId: "call",
  label: "Call",
  primaryEntity: "contact",
  requires: {
    entity: "contact",
    requiredFields: ["phone"],
  },
  mode: "client-redirect",
  clientRun: async (resolved, hooks) => {
    await openSendTextMessageModal(resolved, hooks);
  },
});
